import { HomePage, Login, PageNotFound } from "../Pages";
import ServiceDetail from "../Pages/Service/ServiceDetail";
export const My_Routes = {
  Public_Routes: [
    {
      path: "/login",
      component: <Login />,
    },
    {
      path: "/Home",
      component: <HomePage />,
    },
    {
      path: "/ServiceDetail",
      component: <ServiceDetail />,
    },
  ],

  Private_Routes: [
    {
      path: "*",
      component: <PageNotFound />,
    },
    {
      path: "/",
      component: <HomePage />,
    },
  ],
};
